import type { TMessages } from '@/types/TMessages'

export const messages = {
  ownOfferButton: 'Продать урожай',
} satisfies TMessages
